import SDIcon from './SDIcon'

const IconCarbonPreview = (props) => (
  <SDIcon title='View' data-baseweb='icon' {...props}>
    <path
    d='M30.94,15.66A16.69,16.69,0,0,0,16,5,16.69,16.69,0,0,0,1.06,15.66a1,1,0,0,0,0,.68A16.69,16.69,0,0,0,16,27,16.69,16.69,0,0,0,30.94,16.34,1,1,0,0,0,30.94,15.66ZM16,25c-5.3,0-10.9-3.93-12.93-9C5.1,10.93,10.7,7,16,7s10.9,3.93,12.93,9C26.9,21.07,21.3,25,16,25Z'
    transform='translate(0 0)'
    />
    <path d='M16,10a6,6,0,1,0,6,6A6,6,0,0,0,16,10Zm0,10a4,4,0,1,1,4-4A4,4,0,0,1,16,20Z' transform='translate(0 0)' />
  </SDIcon>
)

export default IconCarbonPreview
